import React from 'react';
import { Loadingbody, LoadingContainer } from './form-loader.styled';

const FormLoader = () => (
  <Loadingbody>
    <LoadingContainer>
      <div className="form-loading-header">
        <div className="header animate" />
      </div>
      <div className="form-loading">
        <div className="form-label animate" />
        <div className="form-select animate" />
      </div>
      <div className="form-loading light">
        <div className="form-label animate" />
        <div className="form-select animate" />
      </div>
      <div className="form-loading lighter">
        <div className="form-label animate" />
        <div className="form-select animate" />
      </div>
      <div className="form-loading lightest">
        <div className="form-label animate" />
        <div className="form-select animate" />
      </div>
    </LoadingContainer>
  </Loadingbody>
);

export default FormLoader;
